let googleAutoCompleteRequestId: string | undefined
let googleAutoCompleteSessionId: string | undefined
let prevAddressMetadata: Record<string, string> | null = null

/** Holds Google Places session token, validate API request id, and address metadata. */
export const addressGoogleAutocompleteHolder = {
  getGoogleAutoCompleteSessionId: () => googleAutoCompleteSessionId,
  getGoogleAutoCompleteRequestId: () => googleAutoCompleteRequestId,
  getPrevAddressMetadata: () => prevAddressMetadata,
  setGoogleAutoCompleteSessionId: (data: string) => {
    googleAutoCompleteSessionId = data
  },
  setGoogleAutoCompleteRequestId: (data: string) => {
    googleAutoCompleteRequestId = data
  },
  setPrevAddressMetadata: (data: Record<string, string> | null) => {
    prevAddressMetadata = data
  },
  reset: () => {
    googleAutoCompleteRequestId = undefined
    googleAutoCompleteSessionId = undefined
    prevAddressMetadata = null
  },
}
